import React from 'react';
import CardLayout from '../../../../../shared/components/card/CardLayout';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSocialPlatform } from '../../../../../shared/hooks/useSocialPlatform';
import { IMoodashFilterState } from '../../../../../shared/hooks/useMoodashData';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import { MoodashActivePlatforms } from '../dto/IDiscoveryFilter';
import DiscoveryPlatformCard from './DiscoveryPlatformCard';
import { CustomAutocomplete } from '../../../../../shared/components/Autocomplete';
import { useMediaQuery } from '@mui/material';
import { BootstrapBreakpoints } from '../../../../../enum/BootstrapBreakpoints';
import { openUpgradeModal } from '../../../../../store/subscription/subscriptionSlice';

interface IDiscoveryUsernameFilterProps {
    setMoodashFilterParams: React.Dispatch<React.SetStateAction<IMoodashFilterState>>;
    moodashFilters: IMoodashFilterState;
}

const DiscoveryPlatformsFilter = ({ setMoodashFilterParams, moodashFilters }: IDiscoveryUsernameFilterProps) => {
    const { platforms, selectedDefaultPlatform, setSelectedPlatform } = useSocialPlatform({
        isEnabled: true,
        hasApi: true,
    });
    const discoveryProfileViewsLeft = useSelector(
        (state: IAllStates) => state?.auth?.user?.discoveryDetails?.discoveryProfileViewsLeft
    );
    const isDiscoveryLimited = useSelector((state: IAllStates) => state.auth.user.company?.package?.limitDiscovery);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isMobile = useMediaQuery(`(max-width: ${BootstrapBreakpoints.MD}px)`);

    const openUpgradeModalAction = () => {
        if (isDiscoveryLimited) {
            dispatch(
                openUpgradeModal({
                    source: 'platform_filters',
                })
            );
            return;
        }
    };

    const changeHandlerPlatforms = (platformName: MoodashActivePlatforms) => {
        if (isDiscoveryLimited) {
            return openUpgradeModalAction();
        }
        setMoodashFilterParams(prev => ({
            ...prev,
            platform: platformName,
        }));
        const findSelectedPlatform = platforms.find(item => item.name === platformName);
        setSelectedPlatform(findSelectedPlatform ?? selectedDefaultPlatform);
    };

    const changeHandlerPlatformsMobile = (paramKey: string, paramValue: string | string[] | number) => {
        if (isDiscoveryLimited) {
            return openUpgradeModalAction();
        }
        setMoodashFilterParams(prev => ({
            ...prev,
            [paramKey]: paramValue,
        }));
        const findSelectedPlatform = platforms.find(item => item.name === paramValue);
        setSelectedPlatform(findSelectedPlatform ?? selectedDefaultPlatform);
    };
    return (
        <>
            <CardLayout classBody="p-2">
                <Row className="align-items-lg-center justify-content-between">
                    <Col xl={6} lg={8} className="">
                        {isMobile ? (
                            selectedDefaultPlatform && (
                                <CustomAutocomplete
                                    dataArray={platforms}
                                    isWithImage={true}
                                    defaultArray={selectedDefaultPlatform}
                                    queryFilterKey="platform"
                                    inputLabel="platform"
                                    photoLabel="path"
                                    key="platform"
                                    isMultiple={false}
                                    classes="my-2"
                                    isRequired={true}
                                    disableClearable={true}
                                    handleChangeParams={changeHandlerPlatformsMobile}
                                    inputLabelTranslation={`${t('brand.campaign.measure.allPlatforms')}`}
                                    isDisabled={isDiscoveryLimited}
                                />
                            )
                        ) : (
                            <div className="d-flex align-items-center gap-3">
                                {platforms?.length
                                    ? platforms.map(platform => (
                                          <div key={platform?.id} style={{ width: 145, flex: '0 0 145px' }}>
                                              <DiscoveryPlatformCard
                                                  action={changeHandlerPlatforms}
                                                  platform={platform}
                                                  activePlatform={moodashFilters.platform === platform.name}
                                              />
                                          </div>
                                      ))
                                    : null}
                            </div>
                        )}
                    </Col>
                    <Col xl={2} lg={3} className="mt-lg-0 mt-2">
                        <div className="d-flex justify-content-start justify-content-lg-center">
                            <p className="mb-0 text-primary font-weight-bold me-2 fs-5">
                                {discoveryProfileViewsLeft ?? 0}
                            </p>
                            <p className="mb-0 fs-5">{t('brand.campaign.discovery.left_views')}</p>
                        </div>
                    </Col>
                </Row>
            </CardLayout>
        </>
    );
};

export default DiscoveryPlatformsFilter;
